import DeleteAccount from "./DeleteAccount";

export default DeleteAccount;
